<template>
  <div>
    <div v-if="isEmpty(routeProducts)">
      <v-alert color="danger" border="left" dark>
        <v-icon>mdi-alert</v-icon>
        {{ $t('no_products_configured_for_route') }}
      </v-alert>
    </div>
    <div v-else>
      <v-data-table
        hide-default-footer
        :items="routeProducts"
        :headers="tableFields">
        <template #item.product_name="row">
          <router-link :to="`/product/${row.item.product.id}`">{{ row.item.product.name }}</router-link>
        </template>
        <template #item.zone="row">
          {{ $t(row.item.product.zone) }}
        </template>
        <template #item.start_temp="row">
          <span v-if="row.item.start_temp != null">
            {{ row.item.start_temp | temperatureToScale(row.item.temperature_scale, customerContext.tempFormat()) }}&deg;{{ customerContext.tempFormat() }}
          </span>
          <v-icon v-else color="grey lighten-1">mdi-minus</v-icon>
        </template>
        <template #item.verofresh_temperature="row">
          <span v-if="row.item.verofresh_temperature != null">
            {{ row.item.verofresh_temperature | temperatureToScale(row.item.temperature_scale, customerContext.tempFormat()) }}&deg;{{ customerContext.tempFormat() }}
          </span>
          <v-icon v-else color="grey lighten-1">mdi-minus</v-icon>
        </template>
        <template #item.acceptable_range="row">
          <span v-if="row.item.product.min_temp">
            {{ row.item.product.min_temp | temperatureToScale(row.item.temperature_scale, customerContext.tempFormat()) }}&deg;{{ customerContext.tempFormat() }}
          </span>
          &ndash;
          <span v-if="row.item.product.max_temp">
            {{ row.item.product.max_temp | temperatureToScale(row.item.temperature_scale, customerContext.tempFormat()) }}&deg;{{ customerContext.tempFormat() }}
          </span>
        </template>
        <template #item.stats="row">
          <span v-if="row.item.mean">
            {{ row.item.mean | temperatureToScale(row.item.temperature_scale, customerContext.tempFormat()) }}&deg;{{ customerContext.tempFormat() }} /
            {{ row.item.median | temperatureToScale(row.item.temperature_scale, customerContext.tempFormat()) }}&deg;{{ customerContext.tempFormat() }} /
            {{ row.item.std_dev | temperatureToScale(row.item.temperature_scale, customerContext.tempFormat()) }}&deg;{{ customerContext.tempFormat() }}
          </span>
          <v-icon v-else color="grey lighten-1">mdi-minus</v-icon>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import CurrentUserMixin from '@/components/mixins/CurrentUserMixin'
import TemperatureMixin from '@/components/mixins/TemperatureMixin'
import { isEmpty } from 'lodash'

export default {
  name: 'RouteProductTable',
  components: { },
  mixins: [
    CurrentUserMixin,
    TemperatureMixin
  ],
  props: {
    routeProducts: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      isEmpty: isEmpty,
      tableFields: [
        {
          value: 'product_name',
          text: this.$tc('product')
        },
        {
          value: 'zone',
          text: this.$t('zone')
        },
        {
          value: 'start_temp',
          text: this.$t('starting_temperature'),
          align: 'end'
        },
        {
          value: 'verofresh_temperature',
          text: this.$t('ending_temperature'),
          align: 'end'
        },
        {
          value: 'acceptable_range',
          text: this.$t('acceptable_temperature_range'),
          align: 'end'
        },
        {
          value: 'stats',
          text: `${this.$t('mean')} / ${this.$t('median')} / σ`,
          align: 'end'
        }
      ]
    }
  }
}
</script>
